import React, { useState, useEffect } from 'react';
import './App.css'; // Import your CSS file

function App() {

    const [records, setRecords] = useState([]);
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const shapeOptions = ['rectangle', 'circle', 'oval', 'irregular'];
    const machineOptions = ['sanjo', 'viva', 'Durst', 'Aniflo', 'Aniflo viva', 'vinske'];
    
    const [showAddForm, setShowAddForm] = useState(false);
    const [newRecord, setNewRecord] = useState({});
    const [editingRecord, setEditingRecord] = useState(null);

    const handleFilterChange = async (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const formData = new FormData();
            for (const key in filters) {
                formData.append(key, filters[key]);
            }

            const response = await fetch('http://innovadev.innovastore-international.com:3009/getDiecuts', {
                method: 'POST',
                body: formData, // Send FormData
            });

            if (!response.ok) {
                const errorData = await response.json(); // Try to parse error response
                throw new Error(errorData.error || 'Network response was not ok');
            }

            const data = await response.json();
            setRecords(data);

        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    const applyFilters = async () => {  // Separate function for applying filters
        setLoading(true);
        setError(null);

        try {
            const formData = new FormData();
            for (const key in filters) {
                formData.append(key, filters[key]);
            }

            const response = await fetch('http://innovadev.innovastore-international.com:3009/getDiecuts', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Network response was not ok');
            }

            const data = await response.json();
            setRecords(data);
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
          setLoading(true);
          try {
            const response = await fetch('http://innovadev.innovastore-international.com:3009/getDiecuts', {method: 'POST'});
            if (!response.ok) {
                throw new Error('Network response was not ok1');
            }
            const data = await response.json();
            setRecords(data);
          } catch (error) {
            console.error('Error fetching initial data:', error);
            setError(error.message);
          } finally {
            setLoading(false);
          }
        }
        fetchInitialData();
      }, []);

    useEffect(() => {
        applyFilters();
    }, [filters]);


     const handleAddRecord = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const formData = new FormData();
        for (const key in newRecord) {
            formData.append(key, newRecord[key]);
        }

        try {
            const response = await fetch('http://innovadev.innovastore-international.com:3009/addDiecut', { 
                method: 'POST',
                body: formData, 
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Network response was not ok');
            }

            const data = await response.json(); // Assuming your backend returns the newly added record
            setRecords([...records, data]); // Add the new record to the state
            setNewRecord({}); // Clear the form
            setShowAddForm(false); // Hide the form

        } catch (error) {
            console.error('Error adding record:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateRecord = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const formData = new FormData();
        for (const key in editingRecord) {
            if(key !== 'id')
                formData.append(key, editingRecord[key]);
        }

        try {
            const response = await fetch(`http://innovadev.innovastore-international.com:3009/updateDiecut/${editingRecord.id}`, { // Endpoint for updating
                method: 'PUT',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Network response was not ok');
            }

            const updatedRecord = await response.json();
            setRecords(records.map(record => record.id === updatedRecord.id ? updatedRecord : record));
            setEditingRecord(null); // Clear the editing form and state
        } catch (error) {
            console.error('Error updating record:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const startEditingRecord = (record) => {
        setEditingRecord({ ...record }); // Create a copy for editing
    };

    const handleDeleteRecord = async (record) => {
        const confirmed = window.confirm(`Are you sure you want to delete Diecut ?`); // Confirmation popup

        if (confirmed) {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch(`http://innovadev.innovastore-international.com:3009/diecut/?id=${record.id}`, {
                    method: 'DELETE',
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Network response was not ok');
                }

                setRecords(records.filter((r) => r.id !== record.id)); // Remove from state
            } catch (error) {
                console.error('Error deleting record:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        }
    };

    const cancelEditing = () => {
        setEditingRecord(null);
    };

    const handleNewRecordChange = (e) => {
        setNewRecord({ ...newRecord, [e.target.name]: e.target.value });
    };

    const handleEditRecordChange = (e) => {
        setEditingRecord({ ...editingRecord, [e.target.name]: e.target.value });
    };


    return (
        <div className="app-container"> {/* Main container */}
            <h1 className="app-title">Diecuts</h1>

            <div className="filter-container"> {/* Filter area */}
                <form className="filter-form" onSubmit={handleSubmit}>
                    <div className="filter-group"> {/* Grouping for better layout */}
                        <label htmlFor="machine">Machine:</label>
                        <select id="machine" name="machine" onChange={handleFilterChange}>
                          <option value="">Undefined Machine</option> {/* Placeholder option */}
                          {machineOptions.map((machine) => (
                            <option key={machine} value={machine}>
                              {machine}
                            </option>
                          ))}
                        </select>

                    </div>
                    <div className="filter-group">
                        <label htmlFor="shape">Shape:</label>
                        <select id="shape" name="shape" onChange={handleFilterChange}>
                          <option value="">Undefined Shape</option> 
                          {shapeOptions.map((shape) => (
                            <option key={shape} value={shape}>
                              {shape}
                            </option>
                          ))}
                        </select>
                    </div>
                    <div className="filter-group">
                        <label htmlFor="customer">Customer:</label>
                        <input type="text" id="customer" name="customer" placeholder="Customer" onChange={handleFilterChange} />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="shape">Width:</label>
                        <input type="number" id="width" name="width" placeholder="Width (mm)" onChange={handleFilterChange} />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="shape">Height:</label>
                        <input type="number" id="height" name="height" placeholder="Height (mm)" onChange={handleFilterChange} />
                    </div>
                    <div className="filter-group"> {/* New Tolerance filter group */}
                        <label htmlFor="tolerance">Tolerance:</label>
                        <input 
                            type="number" 
                            id="tolerance" 
                            name="tolerance" 
                            placeholder="Tolerance (mm)" 
                            onChange={handleFilterChange} 
                        />
                    </div>
                    <button type="submit" className="filter-button" disabled={loading}>
                        {loading ? 'Loading...' : 'Apply Filters'}
                    </button>
                </form>
            </div>


            <div className="filter-container"> 
                <button onClick={() => setShowAddForm(true)} className="add-button">Add Diecut</button>

            {showAddForm && (
                    <form onSubmit={handleAddRecord} className="diecut-form">
                        {/* Input fields for all record properties */}
                        {Object.keys(records[0] || {})
                        .filter(key => key !== 'id' && key !== 'jomi_id')
                        .map(key => {
                            if (key === 'machine') { 
                                const options = [...new Set(records.map(record => record[key]))]; 
                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <select
                                            id={key}
                                            name={key}
                                            value={newRecord[key] || ''}
                                            onChange={handleNewRecordChange}
                                            required
                                        >
                                            <option value="">Select {key}</option> 
                                            {machineOptions.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            } else if (key === 'shape') { 
                                const options = [...new Set(records.map(record => record[key]))]; 
                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <select
                                            id={key}
                                            name={key}
                                            value={newRecord[key] || ''}
                                            onChange={handleNewRecordChange}
                                            required
                                        >
                                            <option value="">Select {key}</option> 
                                            {shapeOptions.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            } else { 
                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <input
                                            type={typeof records[0]?.[key] === 'number' ? 'number' : 'text'}
                                            id={key}
                                            name={key}
                                            value={newRecord[key] || ''}
                                            onChange={handleNewRecordChange}
                                            required
                                        />
                                    </div>
                                );
                            }
                        })}
                        <button type="submit" className="form-button add-diecut-button" disabled={loading}>
                            {loading ? 'Adding...' : 'Add'}
                        </button>
                        <button type="button" onClick={() => setShowAddForm(false)} className="form-button cencel-button">Cancel</button>
                    </form>
            )}

            {editingRecord && (
                <form onSubmit={handleUpdateRecord} className="diecut-form">
                    {Object.keys(records[0] || {})
                        .filter(key => key !== 'id' && key !== 'jomi_id')
                        .map(key => {
                            if (key === 'machine') {
                                const options = [...new Set(records.map(record => record[key]))];

                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <select
                                            id={key}
                                            name={key}
                                            value={editingRecord[key] || ''} 
                                            onChange={handleEditRecordChange} 
                                        >
                                            <option value="">Select {key}</option>
                                            {machineOptions.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            } else if (key === 'shape') {
                                const options = [...new Set(records.map(record => record[key]))];

                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <select
                                            id={key}
                                            name={key}
                                            value={editingRecord[key] || ''} 
                                            onChange={handleEditRecordChange} 
                                        >
                                            <option value="">Select {key}</option>
                                            {shapeOptions.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={key} className="form-group">
                                        <label htmlFor={key}>{key}:</label>
                                        <input
                                            type={typeof records[0]?.[key] === 'number' ? 'number' : 'text'}
                                            id={key}
                                            name={key}
                                            value={editingRecord[key] || ''} 
                                            onChange={handleEditRecordChange} 
                                            required
                                        />
                                    </div>
                                );
                            }
                        })}
                    <button type="submit" className="form-button update-diecut-button" disabled={loading}>
                        {loading ? 'Updating...' : 'Update'}
                    </button>
                    <button type="button" onClick={cancelEditing} className="form-button cencel-button">Cancel</button>
                </form>
            )}
        
        </div>

             {error && <p style={{ color: 'red' }}>Error: {error}</p>}

            {loading && <p>Loading data...</p>}

            {records.length > 0 && (
                <table className="records-table"> 
                    <thead>
                        <tr>
                            {records.length > 0 && Object.keys(records[0]).map((key) => {
                                const formattedKey = key
                                    .replace(/_/g, ' ') 
                                    .replace(/\b\w/g, (match) => match.toUpperCase()); 

                                return <th key={key}>{formattedKey}</th>;
                            })}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
 
{records.map((record, index) => (
    <tr key={record.id || index}>
        {Object.keys(record).map((key, valueIndex) => { // Iterate over keys
            let tdStyle = {};

            if (key === 'jomi_id' && record.jomi_id) { 
                const colorPart = record.jomi_id.split('-')[1];
                if (colorPart) {

                    let colorF = 'white'
                    if(colorPart === 'yellow' || colorPart === 'white' || colorPart === 'pink'){
                        colorF = 'black'
                    }

                    if(colorPart === 'light'){
                        const colorPart1 = '#F6CEFC'
                        colorF = 'black'
                        tdStyle = { backgroundColor: colorPart1, color: colorF };
                    }else{
                        tdStyle = { backgroundColor: colorPart, color: colorF };                        
                    }

                    
                }
            }

            return (
                <td key={valueIndex} style={tdStyle}>
                    {key === 'jomi_id' ? record.jomi_id : // Display jomi_id or other value
                     typeof record[key] === 'number' && !Number.isInteger(record[key])
                        ? record[key].toFixed(2)
                        : record[key]
                    }
                </td>
            );
        })}
        <td>
            <button onClick={() => startEditingRecord(record)} className="edit-button">
                Edit
            </button>
            <button onClick={() => handleDeleteRecord(record)} className="delete-button">
                Delete
            </button>
        </td>
    </tr>
))}


                    </tbody>
                </table>
            )}
        </div>
    );

}

export default App;